import { Component, OnInit } from '@angular/core';
import { ProductPack } from '../../models/product-pack';
import { Counter } from '../../models/counter';
import { Product } from '../../../order/models/product';
import { environment } from '../../../../../environments/environment';
import { OrderLineType } from '../../../order/models/order-line-type';
import { BookingOrderService } from '../../services/booking-order.service';
import { ProductsStateService } from '../../../order/services/products-state.service';
import { OrderStateService } from '../../../order/services/order-state.service';

@Component({
  selector: 'app-ticket-advanced-configurator',
  templateUrl: 'ticket-advanced-configurator.component.html',
  styleUrls: ['ticket-advanced-configurator.component.scss']
})
export class TicketAdvancedConfiguratorComponent implements OnInit {
  protected _productPacks: ProductPack[] = [];

  constructor(
    private bookingOrderService: BookingOrderService,
    private productsStateService: ProductsStateService,
    private orderStateService: OrderStateService,
  ) {
  }

  ngOnInit(): void {
    this.productsStateService.getAdditionalProducts(this.bookingOrderService.additionalProductsIds)
      .subscribe(x => {
        this.updateProductPacks(x);
      });
  }

  private updateProductPacks(products: Product[]): void {
    products = products ? products : [];
    const productPacks = [];
    const order = this.bookingOrderService.order;
    products.forEach(product => {
      const productId = product.id;
      const orderLine = order.getOrderLineByProductId(productId);
      const count = orderLine ? orderLine.quantity : 0;
      const productPack = new ProductPack(
        product.name,
        product.description,
        `<div class='info'">je <span class='price'>${environment.globalSettings.toMoneyStr(product.price)}</span></div>`,
        [new Counter(productId, count, '', product)],
        product.iconUrl,
        product.description,
        [product],
        product.sequence
      );
      productPacks.push(productPack);
    });
    this._productPacks = productPacks.sort((a, b) => a.sequence - b.sequence);
  }

  onCounterChanged(counter): void {
    const product = counter.tag as Product;
    const order = this.bookingOrderService.order;
    const orderLine = order.getOrderLineByProductId(product.id);
    const count = counter.count;
    const price = this.bookingOrderService.computePriceByProduct(product, count);
    if (orderLine == null) {
      order.addOrderLine(
        OrderLineType.AdditionalProduct,
        product.name,
        product.id,
        price,
        product.taxRate,
        count
      );
    } else if (count > 0) {
      orderLine.quantity = count;
      orderLine.price = price;
    } else {
      order.deleteOrderLine(orderLine);
    }
    order.sortOrderLines();
    this.orderStateService.orderSaveToLocalStorage();
  }

  get productPacks(): ProductPack[] {
    return this._productPacks;
  }
}
